module.exports = __webpack_public_path__ + "static/media/RedKiwi_logo.21adf312.png";